export default [
  {
    path: "/notifications",
    name: "notifications",
    component: () => import("@/views/pages/notifications/Notifications.vue"),
    meta: {
      hasPermission: true,
      pageTitle: "ارسال پیام",
      breadcrumb: [
        {
          text: "ارسال پیام",
          active: true,
        },
      ],
    },
  },
  {
    path: "/notification",
    component: () => import("@/views/pages/notifications/notofications-form/NotificationForm"),

    children: [
      {
        path: ":id/edit",
        name: "notification-edit",
        component: () =>
          import("@/views/pages/notifications/notofications-form/NotificationForm"),

        meta: {
          hasPermission: true,
          pageTitle: "پیام ها",
          breadcrumb: [
            {
              text: "پیام ها",
            },
            {
              text: "پیام ها",
              active: true,
            },
          ],
        },
      },
      {
        path: "/",
        name: "notification-add",
        component: () =>
          import("@/views/pages/notifications/notofications-form/NotificationForm"),

        meta: {
          hasPermission: true,
          pageTitle: "پیام ها",
          breadcrumb: [
            {
              text: "پیام ها",
            },
            {
              text: "پیام ها",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
